import { Typography } from '@mui/material'
import React from 'react'
import { Link } from "react-router-dom";

const NavTitle = () => {
    return (
        <Typography
            component="h1"
            variant="h5"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1 }}
        >
            <Link to="/" style={{
                textDecoration: 'none',
                color:'white'
            }}>
                Sola Procurement
            </Link>
        </Typography>
    )
}

export default NavTitle